import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Col, Row } from "react-bootstrap";
import { useAuth } from "../context/useAuth";
import { useNavigate } from "react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/Forms.css";

export default function RegisterForm() {
    const [t, i18n] = useTranslation("global");
    const { registerUser } = useAuth();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const handleRegister = async (e: any) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const payload = Object.fromEntries(formData);
        if (payload.password !== payload.confirmPassword) {
            setErrorMessage(t("register.errors.passwordsDontMatch"));
            return;
        }
        try {
            registerUser(
                payload.email.toString(),
                payload.username.toString(),
                payload.password.toString()
            );
        } catch (error: any) {
            console.error("Here");
            setErrorMessage(t("register.errors.invalid"));
            return;
        }
    };
    return (
        <>
            <div className="d-flex justify-content-center mt-5">
                <Form className="w-50" onSubmit={handleRegister}>
                    <h1 className="mt-5 mb-5">{t("register.title")}</h1>
                    {errorMessage && (
                        <div className="alert alert-danger" role="alert">
                            {errorMessage}
                        </div>
                    )}
                    <Row>
                        <Col xs={12}>
                            <Form.Group
                                className="mb-3"
                                controlId="formUsername"
                            >
                                <Form.Label>
                                    {t("register.labels.username")}
                                </Form.Label>
                                <Form.Control
                                    required
                                    name="username"
                                    className="custom-input"
                                    type="text"
                                    placeholder={t(
                                        "register.placeholders.username"
                                    )}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Form.Group
                                className="mb-3"
                                controlId="formPassword"
                            >
                                <Form.Label>
                                    {t("register.labels.password")}
                                </Form.Label>
                                <Form.Control
                                    required
                                    className="custom-input"
                                    name="password"
                                    type="password"
                                    placeholder={t(
                                        "register.placeholders.password"
                                    )}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Form.Group
                                className="mb-3"
                                controlId="formConfirmPassword"
                            >
                                <Form.Label>
                                    {t("register.labels.confirmPassword")}
                                </Form.Label>
                                <Form.Control
                                    required
                                    className="custom-input"
                                    name="confirmPassword"
                                    type="password"
                                    placeholder={t(
                                        "register.placeholders.confirmPassword"
                                    )}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="formEmail">
                                <Form.Label>
                                    {t("register.labels.email")}
                                </Form.Label>
                                <Form.Control
                                    required
                                    className="custom-input"
                                    name="email"
                                    type="email"
                                    placeholder={t(
                                        "register.placeholders.email"
                                    )}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col xs={12}>
                            <Button
                                className="w-100 custom-button"
                                variant="primary"
                                type="submit"
                            >
                                {t("buttons.register")}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    );
}
